const googleMapsUrl = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}&libraries=places,drawing&v=weekly&loading=async&callback=initMap`;

export default googleMapsUrl;